<template>
  <div class="animated fadeIn">
    <div class="row">
      <h3>Monitoria</h3>
    </div><!--/.row-->
  </div>
</template>

<script>
export default {
  name: 'monitoring'
}
</script>



// WEBPACK FOOTER //
// src/views/private/monitoring/monitoring.vue